import React from 'react';
import { object, number, string, boolean } from 'yup';
import { startCase } from 'lodash';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '~/commons/config';

const defaults = {
  active: true,
  name: '',
  description: '',
  type: '',
  subType: '',
  price: {
    dge: 0,
    gxe: 0,
  },
  // what data will be affected by this item
  reference: '',
  value: 0,
  maxStack: 99,
  image: '',
};
const schema = object({
  active: boolean().required(),
  name: string().required(),
  description: string(),
  type: string().required(),
  subType: string().required(),
  price: object({
    dge: number().required(),
    gxe: number().required(),
  }).required(),
  reference: string(),
  value: number(),
  maxStack: number(),
  image: string(),
});

const FormItem = ({ item }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: item,
      api: '/api/site/items',
      // onSubmit: (v) => ({
      //   ...v,
      // }),
    }}>
    <div className="form-group">
      <label>Active</label>
      <FormCheckGroup
        name="active"
        type="checkbox"
        label=""
        asSwitch
      />
    </div>
    <FormGroup name="name" label="Name" />
    <FormGroup name="description" label="Description" />
    <div className="row">
      <div className="col">
        <FormGroup name="type" label="Type" as="select">
          <option value=""> - </option>
          {(env?.status?.items?.types || []).map((t) => (
            <option key={t} value={t}>
              {startCase(t)}
            </option>
          ))}
        </FormGroup>
      </div>
      <div className="col">
        <FormGroup
          name="subType"
          label="Sub Type"
          as="select">
          <option value=""> - </option>
          {(env?.status?.items?.subTypes || []).map((t) => (
            <option key={t} value={t}>
              {startCase(t)}
            </option>
          ))}
        </FormGroup>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="price.dge" label="DGE" />
      </div>
      <div className="col">
        <FormGroup name="price.gxe" label="GXE" />
      </div>
    </div>
    <FormGroup name="reference" label="Reference" />
    <FormGroup name="value" label="Value" type="number" />
    <FormGroup name="maxStack" label="Max Stack" type="number" />
    <FormGroup
        name="image"
        label="Image"
        as="coverImg"
        api="/api/site/items/files"
    />

  </FormResource>
);

export default FormItem;
